import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/common/ui/Button.jsx";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import {
  managementUserAction,
  registeredUserActions,
  authActions,
  inmateAction,
} from "../../_store";
import {
  CheckBoxInput,
  DateInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import Table from "../../components/common/table/Table.jsx";
import registeredUserNotesSchema from "../../validation/registeredUserNotesSchema.js";
import registeredUserSchema from "../../validation/registeredUserSchema.js";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import { useLocation } from "react-router-dom";
import { history as historynav } from "../../_helpers/index.js";
import PDFExport from "../../components/common/ui/Export/PDFExport.jsx";
import PrintExport from "../../components/common/ui/Export/PrintExport.jsx";
import generatePDF from "../../components/common/export/generatePDF.js";
import { useReactToPrint } from "react-to-print";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { encryptData } from "./../../utils/encryptDecrypt";
import viewhistroyimg from "../../assets/svg/history.svg";
import approve from "../../assets/svg/Approve-Icon1.svg";

import {
  fDate1,
  fDateTime,
  fDateTimeSuffix,
  formatDateTimeAMPM,
} from "../../utils/formatTime.js";
import { StoredProcedures } from "../../_helpers/enumerator";
import useIPAddress from "../../hooks/useIPAddress.jsx";
import useBrowserType from "../../hooks/useBrowserType.jsx";

const EditPublicUserInfo = () => {
  const location = useLocation();
  let sorting = false;
  const userId = location.state?.userId;
  const activeStatus = location.state?.ActiveStatus;
  const {
    publicUserInformation: publicUserinfo,
    publicUserNotes: publicUsernotes,
    statusHistory,
    statusExcelHistory,
    updateStatusResponse: updatePublicUserStatusResponse,
    updateNotesResponse,
    loadConnectionList: ConnectionList,
    loginhistory: Loadlogininformation,
    fullLoginHistory: loadFullLoginHistory,
    activateAccountManully: activateUserMan,
    loadConnectionFullList: ConnectionExcelData,
    loading,
    allLoginhistory,
    registeredUser,
  } = useSelector((x) => x.registeredUser);
  const [isloading, setisloading] = useState(false);
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const {
    stateDrpList: stateDrplist, // Renaming stateDrpList to stateDrplist
  } = useSelector((x) => x.master);
  const ip = useIPAddress();
  const browser = useBrowserType();

  //DropdownValues
  const { connectionOptions, Status, userStatusOptions, LoginTypeopt } =
    useSelector((x) => x.dropdownOptions);
  const { innerWidth: width, innerHeight: height } = window;
  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const { iframeUser } = useSelector((x) => x.managementUser);
  const dispatch = useDispatch();
  const [showIframe, setShowIframe] = useState(false);
  const iframeRef = useRef(null);

  //Public User Information Page
  const [userStatus, setUserStatus] = useState({
    UserStatus: null,
    UserNotes: "",
  }); // Manage selected value state

  const [setting, setSetting] = useState(false);
  const [connectionAcc, setConnectionAcc] = useState(false);
  const [loginInfoAcc, setLoginInfoAcc] = useState(false);
  //To show the User  page deatils

  const [history, setHistory] = useState({
    PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "PublicUserActiveDeactiveHistoryID DESC",
  });
  const [loginInfo, setLoginInfo] = useState({
    PublicUserID: publicUserinfo[0]?.PublicUserID,
    PageNo: 1,
    RowCountPerPage: 10,
    sortField: "",
    LoginType: 0,
  });
  const [connection, setConnection] = useState({
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  // useEffect(() => {
  //   dispatch(
  //     registeredUserActions.LoadLoginHistory({
  //       PublicUserID: publicUserinfo[0]?.PublicUserID || 0,
  //       LoginType: 2,
  //       PageNo: loginInfo.PageNo,
  //       RowCountPerPage: loginInfo.RowCountPerPage,
  //       sortField: "",
  //     })
  //   );
  // }, [publicUserinfo]);

  // useEffect(() => {
  //   if (publicUserinfo?.length > 0) {
  //     dispatch(
  //       registeredUserActions.LoadAccountStatusHistory({
  //         PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
  //         PageNo: history.PageNo,
  //         RowCountPerPage: history.RowCountPerPage,
  //         SortField: history?.SortField,
  //       })
  //     );
  //   }
  // }, [history?.PageNo, history?.RowCountPerPage, publicUserinfo, userId]);

  // useEffect(() => {
  //   dispatch(
  //     registeredUserActions.LoadLoginHistory({
  //       PublicUserID: publicUserinfo[0]?.PublicUserID,
  //       LoginType: loginType,
  //       PageNo: loginInfo.PageNo,
  //       RowCountPerPage: loginInfo.RowCountPerPage,
  //       sortField: loginInfo.sortField,
  //     })
  //   );
  // }, [loginInfo?.PageNo, loginInfo?.RowCountPerPage]);

  // useEffect(() => {
  //   dispatch(
  //     registeredUserActions.LoadConnectionList({
  //       PublicUserID: publicUserinfo[0]?.PublicUserID,
  //       facilityID: 0,
  //       ManagementUserID: user?.ManagementUserID,
  //       PageNo: connection?.PageNo,
  //       RowCountPerPage: connection?.RowCountPerPage,
  //       SortField: connection?.SortField,
  //     })
  //   );
  // }, [connection]);

  const [loginType, setloginType] = useState(0);

  const [errorMessage, setErrorMessage] = useState({});

  const [showPop, setshowpop] = useState(false);

  const [userNotes, setusernotes] = useState({
    notes: "",
  });

  useEffect(() => {
    if (userId) {
      dispatch(registeredUserActions.GetPublicUserInfo(userId));
    }
  }, [userId]);

  useEffect(() => {
    const statusMessages = {
      1: { text: "User Activated successfully.", icon: "success" },
      2: { text: "User Inactivated successfully.", icon: "success" },
      3: { text: "User Reactivated successfully.", icon: "success" },
      4: { text: "User Deactivated successfully.", icon: "success" },
      5: { text: "User Status updated successfully.", icon: "success" },
      "-1": { text: "Operation failed.", icon: "error" },
      "-2": { text: "User is already active.", icon: "error" },
      "-3": { text: "User is already inactive.", icon: "error" },
      "-4": { text: "User is already activated.", icon: "error" },
      "-5": { text: "User is already deactivated.", icon: "error" },
      "-7": {
        text: "You do not have permission to activate this user. Only the admin who Inactivated this user can activate again.",
        icon: "error",
      },
      "-8": {
        text: "You do not have permission to activate this user. Only the admin who deactivated this user can Reactivate again.",
        icon: "error",
      },
    };

    const statusResponse = updatePublicUserStatusResponse?.IsSucceed;

    if (statusResponse && showPop) {
      const { text, icon } = statusMessages[statusResponse] || {};
      setshowpop(false);

      if (text && icon) {
        showToastNotification(text, icon);
        setUserStatus({
          UserStatus: null,
          UserNotes: "",
        });

        if (publicUserinfo?.[0]?.PublicUserID) {
          dispatch(
            registeredUserActions.GetPublicUserInfo(
              publicUserinfo[0].PublicUserID
            )
          );
        }

        dispatch(registeredUserActions.clearupdateStatusResponse());
      }
    }
  }, [updatePublicUserStatusResponse, showPop, dispatch, publicUserinfo]);

  useEffect(() => {
    if (publicUsernotes && publicUsernotes[0]?.Notes) {
      // If notes exist, set them
      setusernotes({
        notes: publicUsernotes[0]?.Notes,
      });
    } else {
      // If no notes exist, clear the state
      setusernotes({
        notes: "",
      });
    }
  }, [publicUsernotes]);


  useEffect(() => {
    if (loadFullLoginHistory && loadFullLoginHistory?.DataList?.length > 0) {
      const title = "PublicUsersLoginInfo_List";
      const generateExcelColumns = [
        "Signin Browser Type",
        "Signin IP Address",
        "Signin On",
      ];

      // Map the data to match the Excel format

      const new_PublicUsersLoginInfo =
        loadFullLoginHistory?.DataList?.map((obj) => ({
          SignInBrowserType: obj.SignInBrowserType,
          SignInIPAddress: obj.SignInIPAddress,
          SignInDateTime: formatDateTimeAMPM(obj.SignInDateTime),
        })) || [];

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(new_PublicUsersLoginInfo, generateExcelColumns, title);
        dispatch(registeredUserActions.clearLoginInfoExcel());
      } catch (error) { }
    }
  }, [loadFullLoginHistory]);

  useEffect(() => {
    if (ConnectionExcelData && ConnectionExcelData?.DataList?.length > 0) {
      const title = "PublicUserConnections_List";
      const generateExcelColumns = [
        "Inamte ID",
        "Inmate Name",
        "Facility Name",
        "Inmate Status",
        "Relationship",
        "Connection Status",
        "Request Sent Date",
        "Credit Balance",
      ];

      // Map the data to match the Excel format

      const new_PublicUsersConnetion =
        ConnectionExcelData?.DataList?.map((obj) => ({
          InmateID: obj.InmateID,
          InmateName: obj.InmateName,
          FacilityName: obj.FacilityName,
          InmateCurrentStatus: obj.InmateCurrentStatus,
          RelationShip: obj.RelationShip,
          ConnectionStatus: obj.ConnectionStatus,
          RequestSentDate: obj.RequestSentDate,
          CreditBalance: obj.CreditBalance,
        })) || [];

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(new_PublicUsersConnetion, generateExcelColumns, title);
        dispatch(registeredUserActions.clearConnectionExcel());
      } catch (error) { }
    }
  }, [ConnectionExcelData]);

  useEffect(() => {
    if (updateNotesResponse?.IsSucceed === 1) {
      showToastNotification("User Information Updated Successfully", "success");
      // Popup({
      //   title: "Message",
      //   text: `User Information Updated Successfully`,
      //   icon: "success",
      //   confirmButtonText: "Ok",
      // });
      dispatch(
        registeredUserActions.GetPublicUserNotes({
          publicUserID: publicUserinfo[0]?.PublicUserID,
          facilityID: commonFacilityCode,
        })
      );
      dispatch(registeredUserActions.clearupdateNotesresponse());
    } else if (updateNotesResponse?.IsSucceed === -1) {
      showToastNotification("Operation Failed", "error");
      Popup({
        title: "Message",
        text: `Operation Failed`,
        icon: "error",
        confirmButtonText: "Ok",
      });
      // dispatch(
      //   registeredUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(registeredUserActions.clearupdateNotesresponse());
    }
  }, [updateNotesResponse]);

  useEffect(() => {
    if (statusExcelHistory && statusExcelHistory?.DataList?.length > 0) {
      let title = "PublicUserHistory_List";
      let generateExcelColumns = [
        "Public Username",
        "Status",
        "Notes",
        "Modified By",
        "Modified On",
      ];

      // Map the account manager list to match the Excel format
      const history_List = statusExcelHistory?.DataList?.map((obj) => ({
        Public_Username: obj?.PublicUserName || "-",
        Status: obj?.Status || "-",
        Notes: obj?.Notes || "-",
        Modified_By: obj?.CreatedBy || "-",
        Modified_On: formatDateTimeAMPM(obj?.CreatedDate) || "-",
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(history_List, generateExcelColumns, title);

        dispatch(registeredUserActions?.clearSettingExcelHistory());
      } catch (error) { }
    }
  }, [statusExcelHistory]);


  useEffect(() => {
    if (activateUserMan.IsSucceed === 3) {
      showToastNotification(`User Updated Successfully`, "success");
      dispatch(
        registeredUserActions.GetPublicUserInfo(publicUserinfo[0]?.PublicUserID)
      );
      dispatch(registeredUserActions.clearActivateUserRes());
    }
  }, [activateUserMan]);

  //History Column

  const historyColumn = [
    {
      name: "Public Username",
      key: "PublicUserName",
      selector: (row) => row.PublicUserName,
      sortable: true,
    },
    {
      name: "Status",
      key: "Status",
      selector: (row) => row.Status,
      sortable: true,
    },
    {
      name: "Notes",
      key: "Notes",
      selector: (row) => row?.Notes,
      sortable: true,
    },
    {
      name: "Modified By",
      key: "CreatedBy",
      selector: (row) => row.CreatedBy,
      sortable: true,
    },
    {
      name: "Modified On",
      key: "CreatedDate",
      selector: (row) => formatDateTimeAMPM(row.CreatedDate),
      sortable: true,
    },
  ];

  const handleNavToInmate = (row) => {
    dispatch(authActions?.updateCommonFacilityCode(row?.FacilityID));
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    historynav.navigate("InmateList/Details", {
      state: {
        inmate: row,
        source: "RegisteredUser",
        publicUserId: row?.PublicUserID,
        ActiveStatus: activeStatus,
      },
    });
  };

  const ConnectionColumn = [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      Key: "InmateResidentId",
      cell: (row) => (
        <div
          className="Common_Link_Style "
          onClick={() => handleNavToInmate(row)}
        >
          {row.InmateResidentId}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      Key: "InmateName",
      cell: (row) => (
        <div
          className="Common_Link_Style "
          onClick={() => handleNavToInmate(row)}
        >
          {row.InmateName}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Facility Name",
      key: "FacilityName",
      selector: (row) => row.FacilityName,
      sortable: true,
    },
    {
      name: "Inmate Status",
      key: "InmateCurrentStatus",
      selector: (row) => row.InmateCurrentStatus,
      sortable: true,
    },
    {
      width: "130px",
      name: "Relationship",
      key: "RelationShip",
      selector: (row) => row.RelationShip,
      sortable: true,
    },
    {
      name: "Connection Status",
      key: "ConnectionStatus",
      selector: (row) => row.ConnectionStatus,
      sortable: true,
    },
    {
      name: "Request Sent Date",
      key: "RequestSentDate",
      selector: (row) => row.RequestSentDate,
      sortable: true,
    },
    {
      name: "Credit Balance",
      key: "CreditBalance",
      selector: (row) => row?.CreditBalance?.toFixed(2),
      sortable: true,
    },
  ];

  //
  let isConnectionSorting = false;
  const handleconnectionSort = (column, sortDirection) => {
    if (!column?.key) return;
    isConnectionSorting = true;
    const search = { ...connection };
    const newSortOrder = search.SortField?.includes(column.key)
      ? search.SortField.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortField = `${column.key} ${newSortOrder}`;
    setConnection(search);

    dispatch(
      registeredUserActions.LoadConnectionList({
        PublicUserID: publicUserinfo[0]?.PublicUserID,
        facilityID: 0,
        ManagementUserID: user?.ManagementUserID,
        PageNo: connection?.PageNo,
        RowCountPerPage: connection?.RowCountPerPage,
        SortField: search.SortField,
      })
    );
  };

  const LHColumn = [
    {
      key: "SignInBrowserType",
      name: "Signin Browser Type",
      selector: (row) => row.SignInBrowserType,
      sortable: true,
    },
    {
      key: "SignInIPAddress",
      name: "Signin IP Address",
      selector: (row) => row.SignInIPAddress,
      sortable: true,
    },
    {
      key: "SignInDateTime",
      name: "Signin On",
      selector: (row) => formatDateTimeAMPM(row.SignInDateTime),
      sortable: true,
    },
  ];

  const handleRadiobtn = (e) => {
    setloginType(parseInt(e.target.value));
    setLoginInfo((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: 10,
      LoginType: parseInt(e.target.value),
    }));
    dispatch(
      registeredUserActions.LoadLoginHistory({
        PublicUserID: publicUserinfo[0].PublicUserID,
        LoginType: parseInt(e.target.value),
        PageNo: 1,
        RowCountPerPage: 10,
        sortField: "",
      })
    );
  };

  /// Excel download
  const handleClickExcel = () => {
    const updateTotalRows = {
      PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
      RowCountPerPage: statusHistory?.TotalRecordCount,
      SortField: history?.SortField,
      exportExcel: true,
      PageNo: 1,
    };
    dispatch(registeredUserActions.LoadAccountStatusHistory(updateTotalRows));
  };

  const handlePageChange = (newPage, TableName) => {
    if (newPage > 0) {
      // Update the page number

      if (TableName === "History") {
        if (isHistorySort) {
          isHistorySort = false;
          return;
        }
        setHistory((prev) => ({
          ...prev,
          PageNo: newPage,
        }));
        dispatch(
          registeredUserActions.LoadAccountStatusHistory({
            PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
            PageNo: newPage,
            RowCountPerPage: history.RowCountPerPage,
            SortField: history?.SortField,
          })
        );
      } else if (TableName === "Connection") {
        if (isConnectionSorting) {
          isConnectionSorting = false;
          return;
        }
        setConnection((prev) => ({
          ...prev,
          PageNo: newPage,
        }));
        dispatch(
          registeredUserActions.LoadConnectionList({
            PublicUserID: publicUserinfo[0]?.PublicUserID,
            facilityID: 0,
            ManagementUserID: user?.ManagementUserID,
            PageNo: newPage,
            RowCountPerPage: connection?.RowCountPerPage,
            SortField: connection?.SortField,
          })
        );
      } else if (TableName === "LoginHistory") {
        if (isLoginSorting) {
          isLoginSorting = false;
          return;
        }

        setLoginInfo((prev) => ({
          ...prev,
          PageNo: newPage,
        }));
        dispatch(
          registeredUserActions.LoadLoginHistory({
            PublicUserID: publicUserinfo[0]?.PublicUserID,
            LoginType: loginType,
            PageNo: newPage,
            RowCountPerPage: loginInfo.RowCountPerPage,
            sortField: loginInfo.sortField,
          })
        );
      } else if (TableName === "") {
        // dispatch(registeredUserActions.LoadRegisteredPublicUserList(InputParams));
      }
    }
  };

  let isHistorySort = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isHistorySort = true;
    const search = { ...history };
    const newSortOrder = search.SortField?.includes(column.key)
      ? search.SortField.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortField = `${column.key} ${newSortOrder}`;
    setHistory(search);

    dispatch(
      registeredUserActions.LoadAccountStatusHistory({
        ...history,
        PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  // const handleSortConnection = (column, sortDirection) => {
  //   if (!column?.Key) return;
  //   sorting = true;
  //   const search = { ...connection };
  //   const newSortOrder = search.SortField?.includes(column.Key)
  //     ? search.SortField.endsWith("ASC")
  //       ? "DESC"
  //       : "ASC"
  //     : "ASC";
  //   search.SortField = `${column.Key} ${newSortOrder}`;
  //   setConnection(search);

  //   // dispatch(
  //   //   registeredUserActions.LoadConnectionList({
  //   //     PublicUserID: publicUserinfo[0]?.PublicUserID,
  //   //     facilityID: 0,
  //   //     ManagementUserID: user?.ManagementUserID,
  //   //     PageNo: connection?.PageNo,
  //   //     RowCountPerPage: connection?.RowCountPerPage,
  //   //     SortField: `${column.Key} ${newSortOrder}`,
  //   //   })
  //   // );
  // };

  // Handle rows per page change (optional)
  const handleRowsPerPageChange = (newRowsPerPage, TableName) => {
    // Update the number of rows per page
    if (TableName === "History") {
      setHistory((prev) => ({
        ...prev,
        PageNo: 1,
        RowCountPerPage: newRowsPerPage,
      }));
      dispatch(
        registeredUserActions.LoadAccountStatusHistory({
          PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
          PageNo: 1,
          RowCountPerPage: newRowsPerPage,
          SortField: history?.SortField,
        })
      );
    } else if (TableName === "Connection") {
      setConnection((prev) => ({
        ...prev,
        PageNo: 1,
        RowCountPerPage: newRowsPerPage,
      }));
      dispatch(
        registeredUserActions.LoadConnectionList({
          PublicUserID: publicUserinfo[0]?.PublicUserID,
          facilityID: 0,
          ManagementUserID: user?.ManagementUserID,
          PageNo: 1,
          RowCountPerPage: newRowsPerPage,
          SortField: connection?.SortField,
        })
      );
    } else if (TableName === "LoginHistory") {
      setLoginInfo((prev) => ({
        ...prev,
        PageNo: 1,
        RowCountPerPage: newRowsPerPage,
      }));
      dispatch(
        registeredUserActions.LoadLoginHistory({
          PublicUserID: publicUserinfo[0]?.PublicUserID,
          LoginType: loginType,
          PageNo: 1,
          RowCountPerPage: newRowsPerPage,
          sortField: loginInfo.sortField,
        })
      );
    }
  };

  let isLoginSorting = false;
  const handleLoginSort = (column, sortDirection) => {
    if (!column?.key) return;

    isLoginSorting = true;

    const search = { ...loginInfo };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    setLoginInfo(search);

    dispatch(
      registeredUserActions.LoadLoginHistory({
        ...loginInfo,
        PublicUserID: publicUserinfo[0]?.PublicUserID,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleValidateEmail = (email) => {
    if (email) {
      setisloading(true);
      dispatch(
        registeredUserActions.ValidateResendActivationEligibility(email)
      ).then((x) => {
        const validateEmail = x?.payload;
        setisloading(false);
        let params = {
          email: publicUserinfo[0]?.Email,
        };
        if (validateEmail.IsResendActivationAllowed) {
          Popup({
            title: "Message",
            text: `Are you sure you want to send a confirmation mail to ${publicUserinfo[0]?.Email}`,
            icon: "info",
            confirmButtonText: "Ok",
            cancelButtonText: "Cancel",
            onConfirm: () => {
              setisloading(true);
              dispatch(registeredUserActions.ResendActivationEmail(params)).then((x) => {
                const resendActivationEmail = x?.payload;
                setisloading(false);
                if (resendActivationEmail.IsSucceed === 1) {
                  showToastNotification(
                    `Confirmation mail sent to ${publicUserinfo[0].Email} for activate the account.`,
                    "success"
                  );
                  dispatch(registeredUserActions.clearresendActivationEmail());
                }
              })
            }
          });
          dispatch(registeredUserActions.clearvalidateresendEmailVerification());
        } else if (validateEmail.IsResendActivationAllowed === false) {
          Popup({
            title: "Message",
            text: `${validateEmail.AlertMessage}`,
            icon: "info",
            confirmButtonText: "Ok",
          });
          dispatch(registeredUserActions.clearvalidateresendEmailVerification());
        }
      });
    }
  };

  const handleActivateUser = () => {
    let params = {
      PublicUserID: publicUserinfo[0]?.PublicUserID,
      CreatedBy: user?.ManagementUserID,
    };

    if (params?.PublicUserID && params?.CreatedBy) {
      Popup({
        title: "Message",
        text: `Are you sure you want to activate this user?`,
        icon: "info",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        onConfirm: () =>
          dispatch(registeredUserActions.ActivateAccountManually(params)),
      });
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-GB", options)
      .format(date)
      .replace(",", "") // Remove the comma
      .replace(/\s(am|pm)/i, (match) => match.toUpperCase()); // Capitalize AM/PM
  };

  const handleBack = () => {
    // Clear specific cookies
    // List of cookies to clear
    // List of cookies to clear
    const cookiesToClear = [
      "user",
      "token",
      "userID",
      "PUPasswordLogID",
      "isAuthenticated",
    ];

    cookiesToClear.forEach((cookieName) => {
      document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure`;
    });

    setShowIframe(false);
    dispatch(registeredUserActions.clearpublicUserNotes());
    //   setShowPublicUserInfo(false);
    setUserStatus({
      UserStatus: null,
      UserNotes: "",
    });
    const searchParams = { ...registeredUser };
    // searchParams.PageNo = 1;
    // searchParams.RowCountPerPage = 10;
    dispatch(registeredUserActions.setRegisteredUser(searchParams)); //reset search value..bcz no records found when page in last page
    historynav.navigate("/Admin/RegisteredUserList");
  };

  const handleAccordian = (e, position) => {
    const { checked } = e?.target;
    switch (position) {
      case 1:
        setSetting(checked);
        if (checked) {
          setisloading(true);
          dispatch(
            registeredUserActions.GetPublicUserNotes({
              publicUserID: publicUserinfo[0]?.PublicUserID,
              facilityID: commonFacilityCode,
            })
          ).then(() => setisloading(false));
        }
        break;

      case 2:
        setConnectionAcc(checked);
        if (checked) {
          setisloading(true);
          dispatch(
            registeredUserActions.LoadConnectionList({
              PublicUserID: publicUserinfo[0]?.PublicUserID,
              facilityID: 0,
              ManagementUserID: user?.ManagementUserID,
              PageNo: connection?.PageNo,
              RowCountPerPage: connection?.RowCountPerPage,
              SortField: connection?.SortField,
            })
          ).then(() => setisloading(false));
        }
        break;

      case 3:
        setLoginInfoAcc(checked);
        if (checked) {
          setisloading(true);
          dispatch(
            registeredUserActions.LoadLoginHistory({
              PublicUserID: publicUserinfo[0].PublicUserID,
              LoginType: loginType,
              PageNo: loginInfo.PageNo,
              RowCountPerPage: loginInfo.RowCountPerPage,
              sortField: loginInfo?.sortField,
            })
          ).then(() => setisloading(false));
        }
        break;
      default:
        break;
    }
  };

  const handleHistory = () => {
    dispatch(
      registeredUserActions.LoadAccountStatusHistory({
        PublicUserID: publicUserinfo[0]?.PublicUserID || userId,
        PageNo: history?.PageNo,
        RowCountPerPage: history?.RowCountPerPage,
        SortField: history?.SortField,
      })
    );
  };

  //Settings
  const handleUserStatusChange = (value, fieldName) => {
    setErrorMessage({});
    setUserStatus({ ...userStatus, [fieldName]: value });
  };

  const handleUpdateStatus = (e) => {
    e.preventDefault();

    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = registeredUserSchema(userStatus);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    setshowpop(true);
    dispatch(
      registeredUserActions.UpdateStatus({
        PublicUserID: publicUserinfo[0]?.PublicUserID,
        StatusID: userStatus?.UserStatus,
        Notes: userStatus?.UserNotes,
        CreatedBy: user?.ManagementUserID || 0,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
        UserAction: `Modified User Status As ${userStatus?.UserStatus === "1"
          ? "Active"
          : userStatus?.UserStatus === "2"
            ? "Inactive"
            : userStatus?.UserStatus === "3"
              ? "Reactivate"
              : userStatus?.UserStatus === "4"
                ? "Deactivate"
                : "Unknown"
          } ( PublicUserID - ${publicUserinfo[0]?.PublicUserID} )`,
      })
    );
  };

  const handleChangeNotes = ({ target: { value } }) => {
    setErrorMessage({});
    setusernotes((prev) => ({
      ...prev,
      notes: value,
    }));
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = registeredUserNotesSchema({ notes: value });

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`textarea[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }
  };

  const handleUpdateNote = (e) => {
    e.preventDefault();

    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = registeredUserNotesSchema(userNotes);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`textarea[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    dispatch(
      registeredUserActions.UpdateNotes({
        PublicUserID: publicUserinfo[0].PublicUserID,
        facilityID: commonFacilityCode,
        notes: userNotes?.notes,
        createdBy: user?.ManagementUserID,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PublicNotesInsertUpdate,
        UserAction: `Updated Public User Notes ( PublicUserID - ${publicUserinfo[0].PublicUserID} )`,
      })
    );
  };

  const handleResetNotes = () => {
    setErrorMessage({});
    setusernotes((prev) => ({
      ...prev,
      notes: publicUsernotes[0]?.Notes ? publicUsernotes[0]?.Notes : "",
    }));
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
  };

  //Connection Page

  // const handleConnection = () => {
  //   setConnectionAcc(!connectionAcc);
  //   dispatch(
  //     registeredUserActions.LoadConnectionList({
  //       PublicUserID: publicUserinfo[0]?.PublicUserID,
  //       facilityID: 0,
  //       ManagementUserID: user?.ManagementUserID,
  //       PageNo: connection?.PageNo,
  //       RowCountPerPage: connection?.RowCountPerPage,
  //     })
  //   );
  // };

  const handleConnectionExcel = () => {
    // Dispatch action to load the full list for Excel export
    dispatch(
      registeredUserActions.LoadConnectionList({
        PublicUserID: publicUserinfo[0]?.PublicUserID,
        facilityID: 0,
        ManagementUserID: user?.ManagementUserID,
        PageNo: 1,
        RowCountPerPage: ConnectionList?.TotalRecordCount,
        SortField: connection?.SortField,
        exportExcel: true,
      })
    );
  };



  const GridformatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const handleLoginInfoExcel = () => {
    // Dispatch action to load the full list for Excel export
    dispatch(
      registeredUserActions.LoadLoginHistory({
        PublicUserID: publicUserinfo[0]?.PublicUserID,
        LoginType: loginType,
        PageNo: 1,
        RowCountPerPage: Loadlogininformation?.TotalRecordCount,
        exportExcel: true,
        sortField: loginInfo?.sortField,
      })
    );
  };

  const handleClickPDF = () => {
    let title = "PUBLIC USER INFORMATION";
    let pdfdata = publicUserinfo?.map((obj) => ({
      FirstName: obj.FirstName,
      LastName: obj.LastName,
      Username: obj.UserName,
      Email: obj.Email,
      Gender: obj.Gender === "1" ? "Male" : "Female",
      DOB: obj.DOB,
      SignupIPAddress: obj.SignUpIPAddress,
      SignupBrowserType: obj.SignUpBrowserType || "Unknown",
      PhoneNumber: obj.CellPhone,
      City: obj.City,
      State: obj.StateName,
      ZIP: obj.ZIP,
      LastLoginOn: obj.LastLoginDateTime,
      ActivatedDate: obj.UserActivateDate,
      Status: obj.ActiveStatus === 1 ? "Active" : "Inactive",
      AccountDeactivated: obj.DeactivateHisAccount,
      DeactivatedDate: obj.DeactivatedDate,
      // IsSubscribeMail: obj.IsSubscribeMail,
    }));
    const tableRows = Object.entries(pdfdata[0]).map(([key, value]) => ({
      label: key.replace(/([A-Z])/g, " $1").trim(), // Convert camelCase to readable label
      value: value || "N/A", // Fallback for null or undefined values
    }));
    try {
      generatePDF(tableRows, false, title);
    } catch (error) {
      // Handle any errors that occur during PDF generation
      console.error("Error generating PDF:", error);
    }
  };

  const componentRef = useRef(); // Reference to the component that will be printed

  const [isPrintData, setisPrintData] = useState(false);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
        // size: 4in 5in;
       size: A4 portrait;
        margin: 0 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        color: black !important;
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,
    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handlePrintShow = () => {
    if (publicUserinfo.length > 0) {
      setisPrintData(true);
      setTimeout(() => {
        handlePrints();
      }, 5);
      setTimeout(() => {
        setisPrintData(false);
      }, 2);
    }
  };


  const handleShowIframe = async () => {
    setisloading(true);
    let encryptPwd = encryptData(publicUserinfo[0].UserPassword);
    let BrowserType = browser;

    dispatch(
      managementUserAction.GetPublicLoginValidate({
        UserName: publicUserinfo[0]?.UserName,
        UserPassword: encryptPwd,
        BrowserType: BrowserType,
        IPAddres: ip || "::1",
      })
    );

    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.UsingIframe,
        UserAction: `Viewed Public User Module - Via Public User Page`,
      })
    );
    setisloading(false);
    setIsIframeLoading(true);
    setShowIframe(true);
  };

  const handleButtonClick = () => {
    setShowIframe((prev) => !prev);
    dispatch(
      registeredUserActions.GetPublicUserInfo(publicUserinfo[0]?.PublicUserID)
    );
  };



  return (
    <div>
      {(loading || isloading) ? <CustomLoader /> :
        <>
          <div className="Information">

            {!showIframe && (
              <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
                <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
                  <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap mb-2">
                    <h2 className="mb-4 form_title_uppercase text-color">
                      INFORMATION
                    </h2>
                    <div className="d-flex flex-wrap align-items-center gap-3">
                      <div className="d-flex flex-wrap justify-content-start gap-3">
                        {publicUserinfo[0]?.ActiveStatus === 1 &&
                          publicUserinfo[0]?.UserActivate === 1 &&
                          publicUserinfo[0]?.DeactivateMyAccount === 0 && (
                            <Button
                              variant="green"
                              className="me-2"
                              label={"VIEW AS PUBLIC USER"}
                              type={"button"}
                              status={"btn-label"}
                              icon={"fa-solid fa-eye"}
                              disabled={false}
                              // onClick={() => setShowIframe(true)}
                              onClick={() => handleShowIframe()}
                            />
                          )}

                        {((publicUserinfo[0]?.UserActivate === 0 &&
                          publicUserinfo[0]?.UserActivateDate === null) ||
                          (publicUserinfo[0]?.UserActivate === 0 &&
                            publicUserinfo[0]?.UserActivateDate !== null &&
                            publicUserinfo[0]?.ActiveStatus === 1 &&
                            publicUserinfo[0]?.DeactivateMyAccount === 0)) && (
                            <div className="d-flex flex-wrap gap-2">
                              <Button
                                variant="blue"
                                className="me-2"
                                label={"Activate User Manually"}
                                type={"button"}
                                imgsrc={approve}
                                status={"btn-label"}
                                disabled={false}
                                onClick={() => handleActivateUser()}
                              />
                              <Button
                                variant="yellow"
                                className="me-2"
                                label={"Resend Confirmation Mail"}
                                type={"button"}
                                status={"btn-label"}
                                disabled={false}
                                onClick={() =>
                                  handleValidateEmail(publicUserinfo[0]?.Email)
                                }
                              />
                            </div>
                          )}
                      </div>
                      <div className="ms-auto d-flex flex-wrap gap-3">
                        <PDFExport
                          handlePDFExport={handleClickPDF}
                          className="btn btn-primary me-2" // Adds margin to the right of this button
                        />

                        <PrintExport
                          handlePrintShow={handlePrintShow}
                          className="btn btn-primary ms-2" // Adds margin to the left of this button
                        />
                        <Button
                          variant="primary"
                          className="me-2"
                          label={"Back"}
                          type={"button"}
                          status={"primary"}
                          icon={"fa-solid fa-angle-left"}
                          onClick={handleBack}
                          disabled={false}
                        />
                      </div>
                    </div>
                  </div>
                  <form className="w-100">
                    <div>
                      <h4 className="inner-header-bg text-color">
                        {" "}
                        <i className="fa-solid fa-circle-info me-2"></i>Public
                        User Information{" "}
                      </h4>
                      <div>
                        <div className="row ">
                          {/* First Row */}
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="FirstName"
                                id="FirstName"
                                label="First Name"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.FirstName
                                }
                                placeholder="FirstName"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="LastName"
                                id="LastName"
                                label="Last Name"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.LastName
                                }
                                placeholder="Lastname"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="UserName"
                                id="UserName"
                                label="Username"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.UserName
                                }
                                placeholder="UserName"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Email"
                                id="Email"
                                label="E-mail"
                                value={publicUserinfo && publicUserinfo[0]?.Email}
                                placeholder="E-mail"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <SelectInput
                                options={[
                                  { value: "1", label: "Male" },
                                  { value: "2", label: "Female" },
                                ]}
                                value={
                                  publicUserinfo && publicUserinfo[0]?.Gender
                                }
                                labelKey="label"
                                valueKey="Gender"
                                isMulti={false}
                                isDisabled={true}
                                isClearable={true}
                                placeholder="Gender"
                                label={"Gender"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <DateInput
                                value={publicUserinfo && publicUserinfo[0]?.DOB}
                                name="DOB"
                                label={"DOB"}
                                required={false}
                                disabled={true}
                                yearDropDown={false}
                                isClearable={false}
                                monthDropDown={false}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="mt-0">
                              <CheckBoxInput
                                label="Unsubscribe e-mail notifications from Inmate Inbox"
                                name="IsSubscribeMail"
                                id="IsSubscribeMail"
                                checked={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.IsSubscribeMail === 0
                                }
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Signup IP Address"
                                id="Signup IP Address"
                                label="Signup IP Address"
                                value={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.SignUpIPAddress
                                }
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Signup Browser"
                                id="Signup Browser"
                                label="Signup Browser"
                                value={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.SignUpBrowserType
                                }
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Signup On"
                                id="Signup On"
                                label="Signup On"
                                value={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.UserSignUpDate
                                }
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="PhoneNumber"
                                id="PhoneNumber"
                                label="Phone Number"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.CellPhone
                                }
                                placeholder="PhoneNumber"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Address 1"
                                id="Address 1"
                                label="Address 1"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.Address1
                                }
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="Address 2"
                                id="Address 2"
                                label="Address 2"
                                value={
                                  publicUserinfo && publicUserinfo[0]?.Address2
                                }
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="City"
                                id="City"
                                label="City"
                                value={publicUserinfo && publicUserinfo[0]?.City}
                                placeholder="City"
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <SelectInput
                                options={stateDrplist}
                                value={
                                  publicUserinfo && publicUserinfo[0]?.StateNameID
                                }
                                labelKey="StateName"
                                valueKey="StateNameID"
                                isMulti={false}
                                isDisabled={true}
                                isClearable={true}
                                placeholder="State"
                                label={"State"}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <TextInput
                                name="ZIP"
                                id="ZIP"
                                label="ZIP"
                                value={publicUserinfo && publicUserinfo[0]?.ZIP}
                                required={false}
                                disabled={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <DateInput
                                value={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.LastLoginDateTime
                                }
                                name="LastLogin On"
                                label={"Last Login On"}
                                required={false}
                                disabled={true}
                                yearDropDown={false}
                                isClearable={false}
                                monthDropDown={false}
                                showTimeSelect={true}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <DateInput
                                value={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.UserActivateDate
                                }
                                name="Activated Date"
                                label={"Activated Date"}
                                required={false}
                                disabled={true}
                                yearDropDown={false}
                                monthDropDown={false}
                                isClearable={false}
                                showTimeSelect={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <RadioInput
                                name="status"
                                label="Status"
                                options={Status}
                                selectedValue={publicUserinfo[0]?.ActiveStatus}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-4">
                            <div className="form-floating mb-3">
                              <CheckBoxInput
                                label="Account Deactivated"
                                name="Account Deactivated"
                                id="Account Deactivated"
                                checked={
                                  publicUserinfo &&
                                  publicUserinfo[0]?.DeactivateMyAccount === 1
                                }
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Print */}

                      <form
                        ref={componentRef}
                        style={
                          isPrintData ? { display: "block" } : { display: "none" }
                        }
                      >
                        <div className="container-fluid">
                          <div className="d-flex flex-wrap justify-content-start mb-2">
                            <p className="mb-0">{new Date().toLocaleString()}</p>
                          </div>
                          <div className="text-center mb-4">
                            <h2 className="form_title_uppercase text-color fw-bold">
                              Public User Information
                            </h2>
                          </div>

                          <table className="table table-bordered ">
                            <tbody>
                              {[
                                {
                                  label: "First Name",
                                  value: publicUserinfo[0]?.FirstName,
                                },
                                {
                                  label: "Last Name",
                                  value: publicUserinfo[0]?.LastName,
                                },
                                {
                                  label: "Username",
                                  value: publicUserinfo[0]?.UserName,
                                },
                                {
                                  label: "E-mail",
                                  value: publicUserinfo[0]?.Email,
                                },
                                {
                                  label: "Gender",
                                  value:
                                    publicUserinfo[0]?.Gender === "1"
                                      ? "Male"
                                      : "Female",
                                },
                                { label: "DOB", value: publicUserinfo[0]?.DOB },
                                {
                                  label: "Signup IP Address",
                                  value: publicUserinfo[0]?.SignUpIPAddress,
                                },
                                {
                                  label: "Signup Browser",
                                  value:
                                    publicUserinfo[0]?.SignUpBrowserType || "N/A",
                                },
                                {
                                  label: "Phone Number",
                                  value: publicUserinfo[0]?.CellPhone,
                                },
                                {
                                  label: "Address 1",
                                  value: publicUserinfo[0]?.Address1,
                                },
                                {
                                  label: "Address 2",
                                  value: publicUserinfo[0]?.Address2,
                                },
                                { label: "City", value: publicUserinfo[0]?.City },
                                {
                                  label: "State",
                                  value: publicUserinfo[0]?.StateName,
                                },
                                { label: "ZIP", value: publicUserinfo[0]?.ZIP },
                                {
                                  label: "Last Login On",
                                  value: publicUserinfo[0]?.LastLoginDateTime,
                                },
                                {
                                  label: "Activated Date",
                                  value: publicUserinfo[0]?.UserActivateDate,
                                },
                                {
                                  label: "Status",
                                  value:
                                    publicUserinfo[0]?.ActiveStatus === 1
                                      ? "Active"
                                      : "Inactive",
                                },
                                {
                                  label: "Account Deactivated",
                                  value:
                                    publicUserinfo[0]?.DeactivateMyAccount === 1
                                      ? "Yes"
                                      : "No",
                                },
                                {
                                  label: "Deactivated Date",
                                  value:
                                    publicUserinfo[0]?.DeactivateAccountDate ||
                                    "N/A",
                                },
                              ].map((item, index) => (
                                <tr key={index}>
                                  <th className="text-start fw-bold">
                                    {item.label}
                                  </th>
                                  <td>{item.value || "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </form>
                    </div>
                  </form>
                  {!showIframe && (
                    <div className="text-white">
                      {/* <p className="fw-bold mb-2">Accordion</p> */}

                      <div className="accordion" id="accordion-setting">
                        <div className="accordion-item border-0">
                          <div className="card mb-3">
                            <div
                              className="accordion-header"
                              id="headingSettings"
                            >
                              <button
                                className={`accordion-button 
                              ${setting ? "" : "collapsed"
                                  } text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#setting-accordian"
                                onClick={() =>
                                  handleAccordian(
                                    { target: { checked: !setting } },
                                    1
                                  )
                                }
                                aria-expanded="false"
                              >
                                Settings
                                {/* <CheckBoxInput
                                label="Settings"
                                name="Settings"
                                id="Settings"
                                onClick={handleSetting}
                                checked={setting}
                              /> */}
                              </button>
                            </div>
                            <div
                              id="setting-accordian"
                              className={`accordion-collapse ${setting ? "show" : "collapse"
                                } p-3`}
                              aria-labelledby="headingSettings"
                            >
                              {/* {publicUserinfo[0]?.UserActivate === 0 && (
                              <div>
                                <h4 className="inner-subheader-bg text-color">
                                  <i class="fa-solid fa-gear me-2"></i>User
                                  Settings
                                </h4>
                                <hr />
                              </div>
                            )} */}
                              {(parseInt(activeStatus) !== 2 &&
                                parseInt(activeStatus) !== 5) ||
                                publicUserinfo?.[0]?.UserActivate === 1 ? (
                                <div className="accordion-body p-0 m-4">
                                  <div className="mb-3">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                                      <h4 className="inner-subheader-bg text-color">
                                        <i class="fa-solid fa-gear me-2"></i>User
                                        Settings
                                      </h4>

                                      {publicUserinfo?.[0]?.UserActivate !==
                                        0 && (
                                          <button
                                            onClick={handleHistory}
                                            data-bs-toggle="modal"
                                            data-bs-target="#register-user-modal"
                                            className="btn button-btn-label d-block  btn-lg w-inherit cursor-pointer me-2"
                                          >
                                            <img
                                              src={viewhistroyimg}
                                              alt=""
                                              className="btn-imgsrc"
                                            />
                                            VIEW HISTORY
                                          </button>
                                        )}
                                      <CommonModal
                                        modalId="register-user-modal"
                                        title="History"
                                        loader={statusHistory?.loading}
                                        bodyContent={
                                          <div>
                                            {statusHistory?.DataList?.length >
                                              0 && (
                                                <div className="d-flex flex-wrap justify-content-end align-items-end mb-2">
                                                  <ExcelExport
                                                    variant="soft-gray"
                                                    handleExcelExport={
                                                      handleClickExcel
                                                    }
                                                  />
                                                </div>
                                              )}
                                            <Table
                                              title={""}
                                              columns={historyColumn}
                                              data={statusHistory?.DataList}
                                              pagination={true}
                                              paginationPerPage={history.RowCountPerPage}
                                              onChangePage={(e) =>
                                                handlePageChange(e, "History")
                                              } // Call API when page changes
                                              onChangeRowsPerPage={(e) =>
                                                handleRowsPerPageChange(
                                                  e,
                                                  "History"
                                                )
                                              } // Handle rows per page change
                                              totalRowCount={
                                                statusHistory?.TotalRecordCount
                                              }
                                              currentPage={history.PageNo}
                                              onSort={handleSort}
                                              serverSideSort
                                              sortColumn={
                                                history?.SortField?.split(" ")[0]
                                              }
                                              sortDirection={
                                                history?.SortField?.split(" ")[1]
                                              }
                                            />
                                          </div>
                                        }
                                        footerContent={
                                          <button
                                            className="btn button-primary"
                                            data-bs-dismiss="modal"
                                            onClick={() => {
                                              setHistory({
                                                PageNo: 1,
                                                RowCountPerPage: 10,
                                                SortField: "",
                                              });
                                            }}
                                          >
                                            Close
                                          </button>
                                        }
                                      />
                                    </div>
                                    <hr />
                                    {publicUserinfo[0]?.UserActivate !== 0 && (
                                      <div>
                                        <div className="">
                                          <div className="row col-md-12">
                                            <div className="col-md-6">
                                              <div className="form-floating mb-3">
                                                <SelectInput
                                                  name={"UserStatus"}
                                                  options={userStatusOptions}
                                                  value={
                                                    userStatus?.UserStatus
                                                      ? userStatus?.UserStatus
                                                      : 0
                                                  }
                                                  handleChange={(
                                                    selectedOption
                                                  ) =>
                                                    handleUserStatusChange(
                                                      selectedOption?.value,
                                                      "UserStatus"
                                                    )
                                                  }
                                                  isClearable={
                                                    userStatus?.UserStatus
                                                      ? true
                                                      : false
                                                  }
                                                  placeholder="-- Select --"
                                                  label={"User Status"}
                                                  errorMessage={errorMessage}
                                                />
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-floating mb-3">
                                                <TextInput
                                                  name="statusNotes"
                                                  id="statusNotes"
                                                  label="User Status Notes"
                                                  value={userStatus?.UserNotes} // Replace with the value for the text area
                                                  handleChange={(e) =>
                                                    handleUserStatusChange(
                                                      e.target.value,
                                                      "UserNotes"
                                                    )
                                                  }
                                                  placeholder="Enter user status notes"
                                                  required={false} // Set as needed
                                                  disabled={false} // Set as needed
                                                  rows={3} // Number of rows for the textarea
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-12">
                                            {publicUserinfo[0]?.ActiveStatus !==
                                              1 && (
                                                <div className="table-responsive">
                                                  <table className="table table-bordered table-hover w-100">
                                                    <thead
                                                      className="text-white text-center"
                                                      style={{
                                                        backgroundColor: "#cc595a",
                                                      }}
                                                    >
                                                      <tr>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Inactivated Reason
                                                        </th>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Inactivated By
                                                        </th>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Inactivated Date
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {(publicUserinfo &&
                                                          publicUserinfo[0]
                                                            ?.InActivatedReason) ||
                                                          "-"}
                                                      </td>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {publicUserinfo &&
                                                          publicUserinfo[0]
                                                            ?.InActivatedBy}
                                                      </td>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {GridformatDate(
                                                          publicUserinfo[0]
                                                            ?.InActiveDate ||
                                                          new Date()
                                                        )}
                                                      </td>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              )}
                                          </div>
                                          <div className="">
                                            {publicUserinfo[0]
                                              ?.DeactivateHisAccount ===
                                              "Yes" && (
                                                <div className="table-responsive">
                                                  <table className="table table-bordered table-hover w-100">
                                                    <thead
                                                      className="text-white text-center"
                                                      style={{
                                                        backgroundColor: "#cc595a",
                                                      }}
                                                    >
                                                      <tr>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Deactivated Reason
                                                        </th>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Deactivated By
                                                        </th>
                                                        <th
                                                          className="text-center text-white"
                                                          style={{ height: "30px" }}
                                                        >
                                                          Deactivated Date
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {(publicUserinfo &&
                                                          publicUserinfo[0]
                                                            ?.DeactivatedReason) ||
                                                          "-"}
                                                      </td>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                          paddingRight: "22px",
                                                        }}
                                                      >
                                                        {publicUserinfo &&
                                                          publicUserinfo[0]
                                                            ?.DeactivatedBy}
                                                      </td>
                                                      <td
                                                        className="text-center font-size-16"
                                                        style={{
                                                          height: "40px",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {GridformatDate(
                                                          publicUserinfo[0]
                                                            ?.DeactiveDate ||
                                                          new Date()
                                                        )}
                                                      </td>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                        <div className="mt-3 d-flex flex-wrap justify-content-end align-item-end">
                                          <Button
                                            className="me-2"
                                            label="Update"
                                            type="submit"
                                            onClick={handleUpdateStatus}
                                            variant="danger"
                                            status={"primary"}
                                            icon={"fa-solid fa-pen-to-square"}
                                            disabled={false}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  {publicUserinfo[0]?.UserActivate !== 0 && (
                                    <div>
                                      <hr />
                                      <div className="mb-3">
                                        <h4 className="inner-subheader-bg text-color">
                                          <i className="fa-solid fa-book me-2"></i>
                                          Notes
                                        </h4>
                                        <div className="row">
                                          <div className="col-12">
                                            <TextAreaInput
                                              name="notes"
                                              id="notes"
                                              label="Notes"
                                              value={userNotes.notes} // Replace with the value for the text area
                                              //   handleChange={handleStatusNotesChange} // Replace with your change handler function
                                              placeholder="Enter user notes"
                                              required={false} // Set as needed
                                              disabled={false} // Set as needed
                                              handleChange={handleChangeNotes}
                                              errorMessage={errorMessage} // Replace with error object if applicable
                                              rows={4} // Number of rows for the textarea
                                            />
                                          </div>
                                        </div>
                                        <div className="mt-3 d-flex flex-wrap justify-content-end gap-3 ">
                                          <Button
                                            className="me-2"
                                            label="Update"
                                            type="submit"
                                            onClick={handleUpdateNote}
                                            variant="danger"
                                            status={"primary"}
                                            icon={"fa-solid fa-pen-to-square"}
                                            disabled={false}
                                          />

                                          <Button
                                            className="me-2"
                                            label="RESET"
                                            icon={"fa-solid fa-rotate-right"}
                                            type="button"
                                            onClick={handleResetNotes}
                                            variant="primary "
                                            status={"secondary"}
                                            disabled={false}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {publicUserinfo[0]?.UserActivate === 0 && (
                                    <b className="table-no-data-text d-flex flex-wrap justify-content-center align-items-center vh-80 fs-4 p-5">
                                      {/* No Records Found */}
                                      No data found
                                    </b>
                                  )}
                                </div>
                              ) : (
                                <b className="table-no-data-text d-flex flex-wrap justify-content-center align-items-center vh-80 fs-4 p-5">
                                  {/* No Records Found */}
                                  No data found
                                </b>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="accordion" id="accordion-connections">
                        <div className="accordion-item border-0">
                          <div className="card mb-3">
                            <div
                              className="accordion-header"
                              id="headingConnections"
                            >
                              <button
                                className={`accordion-button 
                                ${connectionAcc ? "" : "collapsed"
                                  } text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#connections-accordian"
                                onClick={() =>
                                  handleAccordian(
                                    { target: { checked: !connectionAcc } },
                                    2
                                  )
                                }
                                aria-expanded="false"
                              >
                                Connections
                                {/* <CheckBoxInput
                                label="Connections"
                                name="Connections"
                                id="Connections"
                                onClick={handleConnection}
                                checked={connectionAcc}
                              /> */}
                              </button>
                            </div>

                            <div
                              id="accordion-connections"
                              className={`accordion-collapse ${connectionAcc ? "show" : "collapse"
                                } p-3`}
                              aria-labelledby="headingConnections"
                            >
                              <div className="accordion-body p-0 m-4">
                                <div className="mb-3">
                                  <div className="mb-3">
                                    <div className="d-flex flex-wrap justify-content-start gap-3">
                                      <h4 className="inner-subheader-bg text-color">
                                        <i className="fa-solid fa-circle-info me-2"></i>
                                        Inmate Connections
                                      </h4>
                                      {ConnectionList?.DataList?.length > 0 && (
                                        <div className="ms-auto">
                                          <ExcelExport
                                            handleExcelExport={
                                              handleConnectionExcel
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <hr />
                                  </div>
                                  <Table
                                    title={""}
                                    columns={ConnectionColumn}
                                    data={ConnectionList?.DataList}
                                    pagination={true}
                                    onChangePage={(e) =>
                                      handlePageChange(e, "Connection")
                                    }
                                    onChangeRowsPerPage={(e) =>
                                      handleRowsPerPageChange(e, "Connection")
                                    } // Handle rows per page change
                                    totalRowCount={
                                      ConnectionList?.TotalRecordCount
                                    }
                                    currentPage={connection?.PageNo}
                                    paginationPerPage={
                                      connection?.RowCountPerPage
                                    }
                                    onSort={handleconnectionSort}
                                    serverSideSort
                                    sortColumn={
                                      connection?.SortField?.split(" ")[0]
                                    }
                                    sortDirection={
                                      connection?.SortField?.split(" ")[1]
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="accordion" id="accordion-logininfo">
                        <div className="accordion-item border-0">
                          <div className="card mb-3">
                            <div
                              className="accordion-header"
                              id="headingLoginInfo"
                            >
                              <button
                                className={`accordion-button 
                                ${loginInfoAcc ? "" : "collapsed"
                                  } text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#logininfo-accordian"
                                onClick={() =>
                                  handleAccordian(
                                    { target: { checked: !loginInfoAcc } },
                                    3
                                  )
                                }
                                aria-expanded="false"
                              >
                                Login Information
                                {/* <CheckBoxInput
                                label="LOGIN INFORMATION"
                                name="LoginInfo"
                                id="LoginInfo"
                                onClick={handleLoginHistory}
                                checked={loginInfoAcc}
                              /> */}
                              </button>
                            </div>

                            <div
                              id="logininfo-accordian"
                              className={`accordion-collapse ${loginInfoAcc ? "show" : "collapse"
                                } p-3`}
                              aria-labelledby="headingLoginInfo"
                            >
                              {parseInt(activeStatus) !== 5 ? (
                                <div className="accordion-body p-0 m-4">
                                  <div className="mb-3">
                                    <div className="d-flex flex-wrap justify-content-start gap-3">
                                      <h4 className="inner-subheader-bg text-color">
                                        <i className="fa-solid fa-circle-info me-2"></i>{" "}
                                        Login Information
                                      </h4>
                                      <div className="ms-auto">
                                        {Loadlogininformation?.DataList?.length >
                                          0 && (
                                            <ExcelExport
                                              handleExcelExport={
                                                handleLoginInfoExcel
                                              }
                                            />
                                          )}
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                  {/* {allLoginhistory?.DataList?.length > 0 && ( */}
                                  <div className="col-sm-12 col-md-6 col-lg-4">
                                    <div className="form-floating mb-3">
                                      <RadioInput
                                        name="loginType"
                                        // label="loginType"
                                        id="loginType"
                                        options={LoginTypeopt}
                                        selectedValue={loginType}
                                        handleChange={handleRadiobtn}
                                      // disabled={true}
                                      />
                                    </div>
                                  </div>
                                  {/* )} */}
                                  <Table
                                    title={""}
                                    columns={LHColumn}
                                    data={Loadlogininformation?.DataList}
                                    pagination={true}
                                    onChangePage={(e) =>
                                      handlePageChange(e, "LoginHistory")
                                    } // Call API when page changes
                                    onChangeRowsPerPage={(e) =>
                                      handleRowsPerPageChange(e, "LoginHistory")
                                    } // Handle rows per page change
                                    totalRowCount={
                                      Loadlogininformation?.TotalRecordCount
                                    }
                                    currentPage={loginInfo?.PageNo}
                                    paginationPerPage={loginInfo?.RowCountPerPage}
                                    onSort={handleLoginSort}
                                    serverSideSort
                                    sortColumn={
                                      loginInfo?.sortField?.split(" ")[0]
                                    }
                                    sortDirection={
                                      loginInfo?.sortField?.split(" ")[1]
                                    }
                                  />
                                </div>
                              ) : (
                                <b className="table-no-data-text d-flex flex-wrap justify-content-center align-items-center vh-80 fs-4 p-5">
                                  No data found
                                </b>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {showIframe && (
              <div style={{ height: height - 150, width: "100%" }}>
                <div className="d-flex flex-wrap justify-content-end gap-2">
                  <Button
                    variant="secondary"
                    className="me-2 mb-1"
                    label="Back"
                    type="button"
                    status="primary"
                    onClick={handleButtonClick}
                    disabled={false}
                  />
                </div>
                {isIframeLoading && <CustomLoader />}
                <iframe
                  className="mt-1"
                  src={`${process.env.REACT_APP_PUBLIC_USER_DOMAIN
                    }?token=${encodeURIComponent(
                      iframeUser?.LoginToken
                    )}&iframeUserID=${encodeURIComponent(
                      iframeUser?.PublicUserID
                    )}&redirectTo=${encodeURIComponent(iframeUser?.RedirectTo)}
                &UserName=${encodeURIComponent(iframeUser?.UserName)}
                &UserPassword=${encodeURIComponent(iframeUser?.UserPassword)}
                &PUPasswordLogID=${encodeURIComponent(
                      iframeUser?.PUPasswordLogID
                    )}&`}
                  title="description"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    overflow: "scroll", // Ensures no overflow within the iframe
                  }}
                  allowFullScreen
                  onLoad={() => setIsIframeLoading(false)}
                  onError={() => setIsIframeLoading(false)}
                />
              </div>
            )}
          </div>
        </>}
    </div>
  );
};

export default React.memo(EditPublicUserInfo);
